import React from 'react';
import './App.css';
import Header from './Header';
import Ailments from './Ailments';
import ConsultationForm from './ConsultationForm';
import Testimonials from './Testimonials';
import Footer from './Footer';

function App() {
  return (
    <div className="App">
      <div
        className="animated-bg"
        style={{ backgroundImage: `url(/images/background.jpeg)` }}
      />
      <img src="/images/watermark.svg" alt="" className="bg-watermark" />
      <div className="App-content">
        <Header />
        <Ailments />
        <ConsultationForm />
        <Testimonials />
        <Footer />
      </div>
    </div>
  );
}

export default App;
